// src/features/leases/components/ProvenanceBadge.jsx
//
// LSE6 — single-letter circular badge indicating the source of a value.
// S = Spacebase, M = Manual, P = PDF abstraction, C = Computed.
// Color tokens come straight from project_lease_summary_tab_design.md §
// "Provenance treatment" — all four source styles now route through T.
// Task-427: promoted pdf_abstraction, manual, and computed from inline hex
// to T.provenancePdfBg / T.provenancePdf, T.provenanceManualBg / T.provenanceManual,
// and T.warmBeige / T.mid respectively.
import React from "react";
import { T } from "../../../app/tokens.js";

const STYLES = {
  spacebase:       { letter: "S", bg: T.provenanceSpacebaseBg, fg: T.spacebaseBlue,  title: "Spacebase" },
  pdf_abstraction: { letter: "P", bg: T.provenancePdfBg,       fg: T.provenancePdf,  title: "PDF abstraction" },
  manual:          { letter: "M", bg: T.provenanceManualBg,    fg: T.provenanceManual, title: "Manual" },
  computed:        { letter: "C", bg: T.warmBeige,             fg: T.mid,    title: "Computed" },
};

export function ProvenanceBadge({ source }) {
  const s = STYLES[source];
  if (!s) return null;
  return (
    <span
      data-testid={`provenance-badge-${source}`}
      title={s.title}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 14,
        height: 14,
        borderRadius: "50%",
        background: s.bg,
        color: s.fg,
        fontSize: T.fsXxxs,
        fontWeight: T.fwBold,
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      {s.letter}
    </span>
  );
}
